export const generateId = function() {
  return Math.random()
    .toString(36)
    .substr(2, 9);
};



// WEBPACK FOOTER //
// ./src/helpers/utils.js